import axiosInstance from '../config/axios';

//Get wallet transaction history
export const getWalletTransactions = async (userId) => {
    const response = await axiosInstance.get(`/wallet/transactions/${userId}`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        params: { user_id: userId },
    });
    return response.data;
};

// Add wallet amount Post method
export const addWalletAmount = async (data) => {
    const response = await axiosInstance.post('/wallet/add-money', data, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });
    return response.data;
};